import script from "./UCounter.vue?vue&type=script&setup=true&lang=ts"
export * from "./UCounter.vue?vue&type=script&setup=true&lang=ts"

import "./UCounter.vue?vue&type=style&index=0&id=6ef97164&lang=css"

const __exports__ = script;

export default __exports__